import { motion } from "framer-motion";
import { isNil } from "lodash";
import {
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import { useEmbarqueDependencias } from "../../../../contexts/EmbarqueDependenciasContext.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController.js";
import TabelaRedux from "../../../../contexts/Tabela.js";
import { useToast } from "../../../../contexts/ToastContext.tsx";
import {
	isDataDoisMil,
	removeSeconds,
} from "../../../../core/utils/UtilityDates.ts";
import { deletarArquivoViagem } from "../../../../services/ModuloGerenciador/ArquivoViagem.ts";
import {
	cadastraEmbarque,
	editaEmbarquePorId,
} from "../../../../services/ModuloGerenciador/Embarque.js";
import { getTaxaIcmsPorUf } from "../../../../services/ModuloGerenciador/TaxaIcms.js";
import {
	cadastraTemplateEmbarque,
	editaTemplateEmbarquePorId,
} from "../../../../services/ModuloGerenciador/TemplateEmbarque.js";
import { getImagensViagemFinalizadaPorId } from "../../../../services/ModuloGerenciador/Viagens.ts";
import "./CadastroViagem.css";
import {
	getEstiloFrota,
	isDateTimeInRange,
	validateCadastro,
	validateDatasEntregas,
} from "./components/EmbarqueUtils.js";
import Entregas from "./components/Entregas.js";
import FormEmbarqueBottom from "./components/FormEmbarqueBottom.js";
import FormEmbarqueTop from "./components/FormEmbarqueTop.js";
import FormTemplateEmbarque from "./components/FormTemplateEmbarque.js";
import ModaisCadastroViagem from "./components/ModaisCadastroViagem.js";

function CadastroViagem(props) {
	const {
		contextoEmbarque,
		tabelaEmpresa,
		dadosFilial,
		profile,
		contextoEmbarqueMudou,
		setContextoEmbarqueMudou,
	} = useProfile();

	const { showToast } = useToast();

	const {
		unidadeEmbarque,
		empresaSub,
		filial,
		pedido,
		veiculo,
		embalagem,
		status,
		meioPagamento,
		motivo,
		embarqueTemplate,
		mercadoria,
		clientes,
		usuarioGerens,
		fetchFilial,
		fetchPedidos,
		fetchVeiculos,
		fetchEmbalagens,
		fetchStatus,
		fetchMeiosPagamento,
		fetchMotivos,
		fetchMercadorias,
		fetchClientes,
		fetchUnidadeEmbarque,
		fetchEmpresaSub,
	} = useEmbarqueDependencias();

	const navigate = useNavigate();

	const location = useLocation();

	const params = useParams();

	const pathname = location.pathname;

	const entregasCarregadasRef = useRef(false);
	const dadosPreenchidos = useRef(false);

	const [idAtual, setIdAtual] = useState();
	const [isOpenModalImage, setIsOpenModalImage] = useState(false);
	const [imagesFinalizacaoViagem, setImagesFinalizacaoViagem] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const [disable, setDisable] = useState(false);
	const [mostrarInput, setMostrarInput] = useState(false);
	const [simplesNacional, setSimplesNacional] = useState(false);
	const [disabledFreteFiEntrega, setDisabledFreteFiEntrega] = useState([]);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);
	const { setTabelaRedux } = useContext(TabelaRedux);

	const [openInformacao, setOpenInformacao] = useState(false);
	const [loadingCadastro] = useState(false);
	const [values, setValues] = useState([]);
	const [valuesSelect, setValuesSelect] = useState({
		empresa: "",
		filial: "",
		status: "",
		pedido: "",
		destinatario: "",
		placaCavalo: "",
		aceite: "",
		embalagem: "",
		mercadoria: "",
		usuarioResponsavel: "",
		meioPagamento: "",
		meioPagamento2: "",
		motivo: "",
	});
	const [openModalEncontrarVeiculo, setOpenModalEncontrarVeiculo] =
		useState(false);
	const [icmsBackup, setIcmsBackup] = useState();
	const [validator, setValidator] = useState([]);
	const [disabledFreteFiscal, setDisabledFreteFiscal] = useState(true);
	const [icmsEmbutido, setIcmsEmbutido] = useState(false);
	const [entrega, setEntregas] = useState([]);

	const isCadastro = useMemo(() => {
		return pathname.endsWith("/cadastro");
	}, [pathname]);

	const defaultPedidoOptions = useMemo(() => {
		return pedido.slice(0, 15).map((data) => ({
			title: `${data.pedido} - ${data.tipoRota} @ ${data.rota.cidadeDestinoRota.cidade} - ${data.rota.cidadeDestinoRota.abreviacao} - ${data.rota.cidadeOrigemRota.cidade} - ${data.rota.cidadeOrigemRota.abreviacao}`,
			obj: data,
		}));
	}, [pedido]);

	const defaultVeiculoOptions = useMemo(() => {
		return veiculo
			.filter((v) => v.caminhao)
			.sort((a, b) => {
				const placaA = a.caminhao?.placa || "";
				const placaB = b.caminhao?.placa || "";
				return placaA.localeCompare(placaB);
			})
			.slice(0, 15)
			.map((data) => ({
				title: `${data.caminhao?.placa || ""} - ${
					data.proprietarioVeiculo?.nome ?? ""
				}`,
				obj: data,
			}));
	}, [veiculo]);

	const [empresaValido, setEmpresaValido] = useState(true);
	const [pedidoOptions, setPedidoOptions] = useState(defaultPedidoOptions);
	const [veiculoOptions, setVeiculoOptions] = useState(defaultVeiculoOptions);
	const [clienteOptions, setClienteOptions] = useState(
		clientes
			.sort((a, b) => a.nomeFantasia.localeCompare(b.nomeFantasia))
			.slice(0, 15)
			.map((cliente) => ({
				title: cliente.nomeFantasia,
				obj: cliente,
			}))
	);
	const [pedidoValido, setPedidoValido] = useState(true);
	const [previsaoEmbarqueValido, setPrevisaoEmbarqueValido] = useState(true);
	const [previsaoEmbarqueRange, setPrevisaoEmbarqueRange] = useState(true);
	const [dataHoraChegadaEmbarqueRange, setDataHoraChegadaEmbarqueRange] =
		useState(true);
	const [dataHoraEmbarcadoRange, setDataHoraEmbarcadoRange] = useState(true);
	const [previsaoEntregaRange, setPrevisaoEntregaRange] = useState(true);
	const [dataHoraChegadaEntregaRange, setDataHoraChegadaEntregaRange] =
		useState(true);
	const [dataHoraEntregueRange, setDataHoraEntregueRange] = useState(true);
	const [previsaoEntregaValido, setPrevisaoEntregaValido] = useState(true);
	const [destinatarioValido, setDestinatarioValido] = useState(true);

	const adicionarEntrega = useCallback(() => {
		if (entrega[entrega.length - 1]?.pedidoId === 0) {
			showToast(
				"Finalize a entrega atual antes de adicionar uma nova.",
				"info"
			);
			return;
		}
		const uid =
			typeof crypto !== "undefined" && crypto.randomUUID
				? crypto.randomUUID()
				: `tmp-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

		setEntregas((prev) => [
			...prev,
			{
				localKey: uid,
				idEntrega: 0,
				embarqueId: 0,
				pedidoId: 0,
				destinarioId: 0,
				classificacao: 0,
				freteMotorista: 0,
				freteFiscal: 0,
				icms: 0,
				pedagio: 0,
				cte: "",
				nomePedido: "",
			},
		]);
	}, [entrega, showToast]);

	const handleInputChange = useCallback(
		(e, index) => {
			const { name, value } = e.target;
			const list = [...entrega];
			list[index][name] = value;
			setEntregas(list);
		},
		[entrega]
	);

	const buscarTaxaIcms = useCallback(
		async (ufOrigem, ufDestino) => {
			if (!profile?.token || contextoEmbarque === "frota") return;

			await getTaxaIcmsPorUf(profile?.token, ufOrigem, ufDestino)
				.then((result) => {
					const taxaIcmsAqui = result.data[0].taxa;
					if (taxaIcmsAqui === 0) {
						setTaxaIcms(taxaIcmsAqui);
						setValues((current) => ({ ...current, icms: "0" }));
					} else {
						const taxaDividida = taxaIcmsAqui / 100;
						setTaxaIcms(taxaDividida);
					}
				})
				.catch(() => {
					showToast("Rota não Possui Taxa de Icms.", "error");
					setTaxaIcms();
					setValues((current) => ({ ...current, icms: "0.00" }));
					setLoading(false);
				});
		},
		[contextoEmbarque, profile?.token, showToast]
	);

	const opcoesPedido = useMemo(() => {
		return pedido.map((data) => ({
			value: data.pedido,
			label: `${data.pedido} - ${data.tipoRota}`,
			...data,
		}));
	}, [pedido]);

	const handlePedidoEntregaChange = useCallback(
		(option, index, ent) => {
			const selectedOption = option.obj;
			if (selectedOption) {
				const list = [...entrega];
				if (ent?.cte) {
					list[index].cte = ent.cte;
				} else {
					list[index].cte = "";
				}
				if (ent) {
					const dadosEntrega = props.dados?.entrega || [];

					if (dadosEntrega[index].classificacao === 0) {
						list[index].classificacao = "0,00";
					} else if (isNil(dadosEntrega[index].classificacao)) {
						list[index].classificacao = parseFloat(
							dadosEntrega[index].pedido.classificacao.replace(",", ".")
						);
					} else {
						list[index].classificacao = dadosEntrega[index]?.classificacao;
					}

					if (dadosEntrega[index].freteFiscal === 0) {
						list[index].freteFiscal = "0,00";
					} else if (isNil(dadosEntrega[index].freteFiscal)) {
						list[index].freteFiscal = parseFloat(
							dadosEntrega[index].pedido.freteFiscal.replace(",", ".")
						);
					} else {
						list[index].freteFiscal = dadosEntrega[index]?.freteFiscal;
					}

					if (isNil(dadosEntrega[index].pedagio)) {
						list[index].pedagio = parseFloat(
							dadosEntrega[index].pedido.pedagio.replace(",", ".")
						);
					} else if (dadosEntrega[index].pedagio === 0) {
						list[index].pedagio = "0,00";
					} else {
						list[index].pedagio = dadosEntrega[index]?.pedagio;
					}

					if (isNil(dadosEntrega[index].freteMotorista)) {
						list[index].freteMotorista = parseFloat(
							dadosEntrega[index].pedido.freteMotorista.replace(",", ".")
						);
					} else if (dadosEntrega[index].freteMotorista === 0) {
						list[index].freteMotorista = "0,00";
					} else {
						list[index].freteMotorista = dadosEntrega[index]?.freteMotorista;
					}

					list[index].km = parseFloat(selectedOption.km.replace(",", "."));
					list[index].cliente = selectedOption.cliente;
					list[index].embarcador = selectedOption.embarcador;
					list[index].valorEmbarqueId = selectedOption.valorEmbarqueId;
					if (!dadosEntrega[index].destinarioId) {
						list[index].destinarioId = selectedOption.destinarioId;
						list[index].destinatarioTitle = `${
							option.obj.destinatarioPedido.nomeFantasia
						} | ${
							option.obj.destinatarioPedido.apelido
								? option.obj.destinatarioPedido.apelido
								: "Favor, cadastrar apelido de Cliente"
						}`;
					} else {
						list[index].destinarioId = dadosEntrega[index].destinarioId;
						list[index].destinatarioTitle = `${
							dadosEntrega[index].destinatario.nomeFantasia
						} | ${
							dadosEntrega[index].destinatario.apelido
								? dadosEntrega[index].destinatario.apelido
								: "Favor, cadastrar apelido de Cliente"
						}`;
					}
					let icms = dadosEntrega[index].icms;
					if (!icms) {
						icms = parseFloat(selectedOption.icms.replace(",", "."));
					}
				} else {
					list[index].classificacao = parseFloat(
						selectedOption.classificacao.replace(",", ".")
					);
					list[index].cliente = selectedOption.cliente;
					list[index].embarcador = selectedOption.embarcador;
					list[index].km = parseFloat(selectedOption.km.replace(",", "."));
					list[index].freteFiscal = parseFloat(
						selectedOption.freteFiscal.replace(",", ".")
					);
					list[index].pedagio = parseFloat(
						selectedOption.pedagio.replace(",", ".")
					);
					list[index].freteMotorista = parseFloat(
						selectedOption.freteMotorista.replace(",", ".")
					);
					list[index].valorEmbarqueId = selectedOption.valorEmbarqueId;
					list[index].destinarioId = selectedOption.destinarioId;
					list[index].destinatarioTitle = `${
						option.obj.destinatarioPedido.nomeFantasia
					} | ${
						option.obj.destinatarioPedido.apelido
							? option.obj.destinatarioPedido.apelido
							: "Favor, cadastrar apelido de Cliente"
					}`;
				}
				list[index].diClassificacao =
					selectedOption.clientePedido?.diClassificacao;
				list[index].diPedagio = selectedOption.clientePedido?.diPedagio;
				list[index].icmsEmbutido = selectedOption.clientePedido?.icmsEmbutido;

				if (contextoEmbarque !== "frota") {
					list[index].icms = parseFloat(selectedOption.icms.replace(",", "."));
				}

				if (params?.origem === "origem" && params?.contexto === "frota") {
					list[index].icms = 0;
				} else if (!simplesNacional) {
					list[index].icms = parseFloat(selectedOption.icms.replace(",", "."));
				} else if (simplesNacional) {
					list[index].icms = 0;
				}

				if (contextoEmbarque !== "frota") {
					setIcmsEmbutido(selectedOption?.icmsEmbutido);
					buscarTaxaIcms(
						selectedOption.embarcadorEstado,
						selectedOption.destinatarioEstado
					);
				}
				setEntregas(list);
				const disables = [...disabledFreteFiEntrega];
				disables[index] = selectedOption.permiteAlterarFreteFiscal;
				setDisabledFreteFiEntrega(disables);
			}
		},
		[
			contextoEmbarque,
			params,
			entrega,
			props.dados?.entrega,
			simplesNacional,
			disabledFreteFiEntrega,
			buscarTaxaIcms,
		]
	);

	useEffect(() => {
		setValues((prevValues) => ({
			...prevValues,
			entrega,
		}));
	}, [entrega]);

	const removeEntrega = (indexToRemove) => {
		const newList = entrega.filter((_, index) => index !== indexToRemove);
		setEntregas(newList);
	};

	const [verificaMotivo, setVerificaMotivo] = useState(true);

	const [verificaMotorista2, setVerificaMorista2] = useState(true);

	const [openCadastroPedido, setOpenCadastroPedido] = useState(false);

	const [loading, setLoading] = useState(false);

	const [openCadastroUnidadeEmbarque, setOpenCadastroUnidadeEmbarque] =
		useState(false);

	const [openCadastroFilial, setOpenCadastroFilial] = useState(false);

	const handleCloseCadastroPedido = useCallback(() => {
		fetchPedidos(profile?.token);
		setOpenCadastroPedido(false);
	}, [profile?.token, fetchPedidos]);

	const handleCloseCadastroUnidadeEmbarque = useCallback(() => {
		fetchUnidadeEmbarque(profile?.token);
		setOpenCadastroUnidadeEmbarque(false);
	}, [profile?.token, fetchUnidadeEmbarque]);

	const handleCloseCadastroFilial = useCallback(() => {
		fetchFilial(profile?.token);
		setOpenCadastroFilial(false);
	}, [profile?.token, fetchFilial]);

	const handleCloseCadastroEmpresa = useCallback(() => {
		fetchEmpresaSub(profile?.token);
		setOpenCadastroEmpresa(false);
	}, [profile?.token, fetchEmpresaSub]);

	const handleCloseCadastroVeiculo = useCallback(() => {
		fetchVeiculos(profile?.token);
		setOpenCadastroVeiculo(false);
	}, [profile?.token, fetchVeiculos]);

	const handleCloseCadastroCliente = useCallback(() => {
		fetchClientes(profile?.token);
		setOpenCadastroCliente(false);
	}, [profile?.token, fetchClientes]);

	const handleCloseCadastroMercadoria = useCallback(() => {
		fetchMercadorias(profile?.token);
		setOpenCadastroMercadoria(false);
	}, [profile?.token, fetchMercadorias]);

	const handleCloseCadastroEmbalagem = useCallback(() => {
		fetchEmbalagens(profile?.token);
		setOpenCadastroEmbalagem(false);
	}, [profile?.token, fetchEmbalagens]);

	const handleCloseCadastroStatus = useCallback(() => {
		fetchStatus(profile?.token);
		setOpenCadastroStatus(false);
	}, [profile?.token, fetchStatus]);

	const handleCloseCadastroMotivo = useCallback(() => {
		fetchMotivos(profile?.token);
		setOpenCadastroMotivo(false);
	}, [profile?.token, fetchMotivos]);

	const handleCloseCadastroMeioPagamento = useCallback(() => {
		fetchMeiosPagamento(profile?.token);
		setOpenCadastroMeioPagamento(false);
	}, [profile?.token, fetchMeiosPagamento]);

	const handleCloseEncontrarVeiculoIa = useCallback(
		(idVeiculo) => {
			setOpenModalEncontrarVeiculo(false);
			if (!idVeiculo) return;
			const selectedOption = veiculo.find((v) => v.idVeiculo === idVeiculo);
			if (!selectedOption) return;
			setMostrarInput(selectedOption?.caminhao?.frota);
			setVeiculoOptions(defaultVeiculoOptions);
			setValues((current) => ({
				...current,
				veiculoId: selectedOption.idVeiculo,
				placaCavalo: selectedOption.caminhao?.placa,
				placaCarreta: selectedOption.carreta?.placa,
				placaCarreta2: selectedOption.carreta2?.placa,
				proprietario: selectedOption.proprietarioVeiculo?.nome,
				motorista: selectedOption.veiculoMotorista.nome,
				motoristaSelecionadoId: selectedOption.veiculoMotorista.idMotorista,
			}));
			const placa = selectedOption.caminhao?.placa || "";
			setValuesSelect((current) => ({
				...current,
				placaCavalo: {
					obj: placa,
					title: `${placa} - ${selectedOption.proprietarioVeiculo?.nome ?? ""}`,
				},
			}));
			setValidator((current) => ({
				...current,
				validatorPlacaCavalo: "true",
				validatorPlacaCarreta: "true",
				validatorPlacaCarreta2: "true",
				validatorProprietario: "true",
				validatorMotorista: "true",
			}));

			if (selectedOption?.caminhao?.frota) {
				setValidator((current) => ({
					...current,
					validatorPrevisaoEmbarque: "true",
					validatorEmpresa: "true",
				}));
				setPrevisaoEmbarqueValido(true);
				setEmpresaValido(true);
			} else {
				setValidator((current) => ({
					...current,
					validatorPrevisaoEmbarque: values.previsaoEmbarque ? "true" : "false",
					validatorEmpresa: values.empresaId ? "true" : "false",
				}));
				setPrevisaoEmbarqueValido(!!values.previsaoEmbarque);
				setEmpresaValido(!!values.empresaId);
			}

			if (selectedOption.veiculoMotorista?.bloqueado) {
				showToast(
					`O motorista selecionado está bloqueado pelo motivo: ${selectedOption.veiculoMotorista.motivo}`,
					"warning"
				);
			}
		},
		[
			values,
			setValues,
			setValuesSelect,
			setValidator,
			setPrevisaoEmbarqueValido,
			setEmpresaValido,
			setVeiculoOptions,
			setMostrarInput,
			showToast,
			defaultVeiculoOptions,
			veiculo,
		]
	);
	const [openCadastroEmpresa, setOpenCadastroEmpresa] = useState(false);
	const [openCadastroVeiculo, setOpenCadastroVeiculo] = useState(false);
	const [openCadastroCliente, setOpenCadastroCliente] = useState(false);
	const [openCadastroMercadoria, setOpenCadastroMercadoria] = useState(false);
	const [openCadastroEmbalagem, setOpenCadastroEmbalagem] = useState(false);
	const [openCadastroStatus, setOpenCadastroStatus] = useState(false);
	const [openCadastroMotivo, setOpenCadastroMotivo] = useState(false);
	const [openCadastroMeioPagamento, setOpenCadastroMeioPagamento] =
		useState(false);

	const calcular = (taxa) => {
		const taxaCalculada =
			((parseFloat(values.freteFiscal) - parseFloat(taxa)) /
				parseFloat(values.freteFiscal)) *
			100;
		const taxaFormatada = taxaCalculada.toFixed(2).toString();
		setValues((current) => ({ ...current, margem: taxaFormatada }));
	};

	const labelMercadoria = (data) => {
		return <div>{data.label?.split("@")[0].trim()}</div>;
	};

	const labelFrota = (data) => <div>{data.opcao}</div>;

	const labelTemplate = (data) => <div>{data.descricao}</div>;

	const estiloFrota = getEstiloFrota(props);

	const opcoesFrota = useMemo(() => {
		return tabelaEmpresa.Opcoes.map((data) => ({
			value: data.opcao,
			label: data.opcao,
			...data,
		}));
	}, [tabelaEmpresa.Opcoes]);

	const opcoesTemplate = useMemo(() => {
		return embarqueTemplate.map((data) => ({
			value: data.descricao,
			label: data.descricao,
			...data,
		}));
	}, [embarqueTemplate]);

	const rangeDataValidacoes = useMemo(() => {
		return [
			{
				campo: "previsaoEmbarque",
				valor: values.previsaoEmbarque,
				setRange: setPrevisaoEmbarqueRange,
				mensagem:
					"O campo Previsão de Embarque está fora do intervalo permitido.",
			},
			{
				campo: "previsaoEntrega",
				valor: values.previsaoEntrega,
				setRange: setPrevisaoEntregaRange,
				mensagem:
					"O campo Previsão de Entrega está fora do intervalo permitido.",
			},
			{
				campo: "dataHoraChegadaEmbarque",
				valor: values.dataHoraChegadaEmbarque,
				setRange: setDataHoraChegadaEmbarqueRange,
				mensagem:
					"O campo Dt.hr Chegada Embarque está fora do intervalo permitido.",
			},
			{
				campo: "dataHoraChegadaEntrega",
				valor: values.dataHoraChegadaEntrega,
				setRange: setDataHoraChegadaEntregaRange,
				mensagem:
					"O campo Dt.hr Chegada Entrega está fora do intervalo permitido.",
			},
			{
				campo: "dataHoraEmbarcado",
				valor: values.dataHoraEmbarcado,
				setRange: setDataHoraEmbarcadoRange,
				mensagem: "O campo Dt.hr Embarcado está fora do intervalo permitido.",
			},
			{
				campo: "dataHoraEntregue",
				valor: values.dataHoraEntregue,
				setRange: setDataHoraEntregueRange,
				mensagem: "O campo Dt.hr Entregue está fora do intervalo permitido.",
			},
		];
	}, [
		values.previsaoEmbarque,
		values.previsaoEntrega,
		values.dataHoraChegadaEmbarque,
		values.dataHoraChegadaEntrega,
		values.dataHoraEmbarcado,
		values.dataHoraEntregue,
	]);

	const validarRangeData = useCallback(() => {
		let status = true;

		for (const val of rangeDataValidacoes) {
			const { valor, setRange, mensagem } = val;
			if (!valor) {
				setRange(true);
				continue;
			}

			if (!isDateTimeInRange(valor)) {
				setRange(false);
				showToast(mensagem, "error");
				setLoading(false);
				status = false;
			} else {
				setRange(true);
			}
		}
		return status;
	}, [rangeDataValidacoes, showToast]);

	const validateEmptyValues = useCallback(() => {
		setValues((currentValues) => ({
			...currentValues,
			dataEmbarque:
				!currentValues.dataEmbarque || isDataDoisMil(currentValues.dataEmbarque)
					? null
					: removeSeconds(currentValues.dataEmbarque),
			dataEntrega:
				!currentValues.dataEntrega || isDataDoisMil(currentValues.dataEntrega)
					? null
					: removeSeconds(currentValues.dataEntrega),
			previsaoEmbarque:
				!currentValues.previsaoEmbarque ||
				isDataDoisMil(currentValues.previsaoEmbarque)
					? null
					: currentValues.previsaoEmbarque,
			previsaoEntrega:
				!currentValues.previsaoEntrega ||
				isDataDoisMil(currentValues.previsaoEntrega)
					? null
					: currentValues.previsaoEntrega,
			dataHoraChegadaEmbarque:
				!currentValues.dataHoraChegadaEmbarque ||
				isDataDoisMil(currentValues.dataHoraChegadaEmbarque)
					? null
					: removeSeconds(currentValues.dataHoraChegadaEmbarque),
			dataHoraChegadaEntrega:
				!currentValues.dataHoraChegadaEntrega ||
				isDataDoisMil(currentValues.dataHoraChegadaEntrega)
					? null
					: removeSeconds(currentValues.dataHoraChegadaEntrega),
			dataHoraEntregue:
				!currentValues.dataHoraEntregue ||
				isDataDoisMil(currentValues.dataHoraEntregue)
					? null
					: removeSeconds(currentValues.dataHoraEntregue),
			dataHoraEmbarcado:
				!currentValues.dataHoraEmbarcado ||
				isDataDoisMil(currentValues.dataHoraEmbarcado)
					? null
					: removeSeconds(currentValues.dataHoraEmbarcado),
			adicionalEmpresa:
				currentValues.adicionalEmpresa?.split(",").length === 1
					? currentValues.adicionalEmpresa + ",00"
					: currentValues.adicionalEmpresa,
			adicionalMotorista:
				currentValues.adicionalMotorista?.split(",").length === 1
					? currentValues.adicionalMotorista + ",00"
					: currentValues.adicionalMotorista,
			adiantamento:
				currentValues.adiantamento?.split(",").length === 1
					? currentValues.adiantamento + ",00"
					: currentValues.adiantamento,
			saldo:
				currentValues.saldo?.split(",").length === 1
					? currentValues.saldo + ",00"
					: currentValues.saldo,
			classificacao:
				currentValues.classificacao?.split(",").length === 1
					? currentValues.classificacao + ",00"
					: currentValues.classificacao,
		}));
	}, []);

	const cadastrar = async () => {
		setLoading(true);

		const campos = [
			"freteMotorista",
			"pedagio",
			"freteFiscal",
			"classificacao",
			"icms",
			"km",
		];

		entrega.forEach((entrega) => {
			campos.forEach((campo) => {
				if (entrega[campo]) {
					entrega[campo] = parseFloat(String(entrega[campo]).replace(",", "."));
				} else {
					entrega[campo] = 0;
				}
			});
		});

		if (!validarRangeData()) {
			setLoading(false);
			return;
		}

		if (
			validator.validatorEmpresa === "true" &&
			validator.validatorPrevisaoEmbarque === "true" &&
			validator.validatorPedido === "true" &&
			!!values.previsaoEmbarque
		) {
			validateEmptyValues();
			const dataEmbarque = validateCadastro(values);
			dataEmbarque.entrega = validateDatasEntregas(values.entrega);
			if (validaPedidoEntregas() || validaCteEntregas()) {
				return;
			}
			await cadastraEmbarque(dataEmbarque, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						setValues((current) => ({
							...current,
							contexto: contextoEmbarque,
						}));
						setTabelaRedux({});
						showToast("Embarque cadastrado com sucesso!", "success");
						if (result?.data?.mensagem) {
							showToast(result.data.mensagem, "warning");
						}
						navigate("/viagens/" + contextoEmbarque);
					}
				})
				.catch((error) => {
					showToast(
						typeof error.response.data === "string" && !!error.response.data
							? error.response.data
							: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				});
		} else {
			let texto = "O(s) campos a seguir são obrigatorios: ";
			if (validator.validatorEmpresa === "false") {
				setEmpresaValido(false);
				texto += "Empresa - ";
			}
			if (validator.validatorPrevisaoEmbarque === "false") {
				texto += "Previsão Viagem - ";
				setPrevisaoEmbarqueValido(false);
			}
			if (validator.validatorPedido === "false") {
				texto += "Pedido - ";
				setPedidoValido(false);
			}
			if (texto.endsWith(" - ")) {
				texto = texto.slice(0, -3) + ".";
			}
			if (texto.length > 200) {
				texto = texto.substring(0, 200) + "...";
			}
			showToast(texto, "error");
		}
		setLoading(false);
	};

	useEffect(() => {
		if (contextoEmbarqueMudou) {
			setValues((current) => ({
				...current,
				descricao:
					contextoEmbarque === "templateEmbarque" ? "" : current.descricao,
				contexto: contextoEmbarque,
			}));
		}
	}, [contextoEmbarque, contextoEmbarqueMudou]);

	useEffect(() => {
		if (values.frota === "Sim") {
			setMostrarInput(true);
		}
	}, [values.frota]);

	const cadastrarTemplate = async () => {
		setLoading(true);
		const dataEmbarque = validateCadastro(values);
		await cadastraTemplateEmbarque(dataEmbarque, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setValues((current) => ({
						...current,
						contexto: "templateEmbarque",
					}));
					setTabelaRedux({});
					setDadosRequestControllerRedux("Cadastro False Sucesso");
					showToast("Cadastrado com sucesso!", "success");
					navigate("/modelo-viagens");
				}
			})
			.catch((error) => {
				showToast(
					typeof error.response.data === "string"
						? error.response.data
						: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					"error"
				);
			});
		setLoading(false);
	};

	const editarTemplate = async () => {
		setLoading(true);
		const dataEmbarque = validateCadastro(values);
		await editaTemplateEmbarquePorId(dataEmbarque, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					setTabelaRedux({});
					setDadosRequestControllerRedux("Cadastro False Sucesso");
					showToast("Cadastrado com sucesso!", "success");
					navigate("/modelo-viagens");
				}
			})
			.catch((error) => {
				showToast(
					typeof error.response.data === "string"
						? error.response.data
						: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
					"error"
				);
			});
		setLoading(false);
	};

	const validaMotivoCancelado = useCallback(() => {
		if (values.cancelado && !values.motivoId) {
			showToast("Motivo não cadastrado.", "error");
			setLoading(false);
			return true;
		}
		return false;
	}, [values.cancelado, values.motivoId, showToast]);

	const validaPedidoEntregas = useCallback(() => {
		if (values.entrega.length <= 0) return false;
		if (entrega.some((e) => !e.pedidoId)) {
			showToast("Há entregas sem pedido!", "error");
			setLoading(false);
			return true;
		}
		return false;
	}, [entrega, values.entrega, showToast]);

	const validaCteEntregas = useCallback(() => {
		if (values.entrega.length <= 0) return false;
		if (entrega.some((e) => !e.cte)) {
			showToast("Há entregas sem CTE!", "error");
			setLoading(false);
			return true;
		}
		return false;
	}, [entrega, values.entrega, showToast]);

	const editar = async () => {
		const campos = [
			"freteMotorista",
			"pedagio",
			"freteFiscal",
			"classificacao",
			"icms",
			"km",
		];

		entrega.forEach((entrega) => {
			campos.forEach((campo) => {
				if (entrega[campo]) {
					entrega[campo] = parseFloat(String(entrega[campo]).replace(",", "."));
				} else {
					entrega[campo] = 0;
				}
			});
		});

		if (!validarRangeData()) {
			setLoading(false);
			return;
		}
		let previousRoute = location.state?.from;
		if (!previousRoute) {
			setLoading(true);
		}
		if (
			validator.validatorEmpresa === "true" &&
			validator.validatorPrevisaoEmbarque === "true" &&
			validator.validatorPrevisaoEntrega === "true" &&
			validator.validatorPedido === "true" &&
			!!values.previsaoEmbarque &&
			!!values.previsaoEntrega
		) {
			validateEmptyValues();
			const dataEmbarque = validateCadastro(values);
			dataEmbarque.entrega = validateDatasEntregas(values.entrega);
			if (
				validaPedidoEntregas() ||
				validaCteEntregas() ||
				validaMotivoCancelado()
			) {
				return;
			}

			if (
				dataEmbarque?.destinatarioId &&
				typeof dataEmbarque.destinatarioId === "string"
			) {
				dataEmbarque.destinatarioId = parseInt(dataEmbarque.destinatarioId, 10);
			}

			await editaEmbarquePorId(dataEmbarque, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						if (previousRoute === undefined) {
							setValues((current) => ({
								...current,
								contexto: contextoEmbarque,
							}));
							setTabelaRedux({});
						}
						showToast("Editado com sucesso!", "success");
						if (result?.data?.mensagem) {
							showToast(result.data.mensagem, "warning");
						}
						const canGoBack = window.history.state?.idx > 0;
						if (canGoBack) {
							navigate(-1);
						} else {
							navigate("/viagens/" + contextoEmbarque);
						}
					}
				})
				.catch((error) => {
					showToast(
						typeof error.response.data === "string" && !!error.response.data
							? error.response.data
							: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				});
		} else {
			let texto = "O(s) campos a seguir são obrigatorios: ";
			if (validator.validatorEmpresa === "false") {
				setEmpresaValido(false);
				texto += "Empresa - ";
			}
			if (validator.validatorPrevisaoEmbarque === "false") {
				texto += "Previsão Viagem - ";
				setPrevisaoEmbarqueValido(false);
			}
			if (validator.validatorPrevisaoEntrega === "false") {
				texto += "Previsão Entrega - ";
				setPrevisaoEntregaValido(false);
			}
			if (validator.validatorPedido === "false") {
				texto += "Pedido - ";
				setPedidoValido(false);
			}
			if (texto.endsWith(" - ")) {
				texto = texto.slice(0, -3) + ".";
			}
			if (texto.length > 200) {
				texto = texto.substring(0, 200) + "...";
			}
			setLoading(false);
			showToast(texto, "error");
		}
		setLoading(false);
	};

	const abrirWhats = (phoneNumber) => {
		const cleanedNumber = phoneNumber.replace(/\D/g, "");
		const formattedNumber = cleanedNumber.startsWith("55")
			? cleanedNumber
			: `55${cleanedNumber}`;
		const url = `https://wa.me/${formattedNumber}`;
		window.open(url, "_blank");
	};

	const buscarImagemViagemFinalizada = useCallback(async () => {
		if (props.dados?.idEmbarque && profile?.token) {
			try {
				const response = await getImagensViagemFinalizadaPorId({
					embarqueId: props.dados.idEmbarque,
					token: profile?.token,
				});
				const images = (response || [])
					.filter(
						(file) => file.googleStorage && file.googleStorage.documentoUrl
					)
					.map((file) => ({
						id: file.id,
						url: file.googleStorage.documentoUrl,
					}));
				setImagesFinalizacaoViagem(images);
			} catch (error) {
				console.error("Erro ao buscar imagem da viagem finalizada:", error);
			}
		}
	}, [props.dados, profile?.token]);

	const handleDeleteImage = useCallback(
		(imageId) => {
			if (!imageId) {
				showToast("Imagem não encontrada.", "error");
				setLoading(false);
				return;
			}
			deletarArquivoViagem({
				id: imageId,
				token: profile?.token,
			})
				.then(() => {
					showToast("Imagem deletada com sucesso.", "success");
					buscarImagemViagemFinalizada();
				})
				.catch((error) => {
					showToast(
						typeof error.response.data === "string" && !!error.response.data
							? error.response.data
							: "Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte.",
						"error"
					);
				});
		},
		[profile?.token, buscarImagemViagemFinalizada, showToast]
	);

	useEffect(() => {
		if (contextoEmbarqueMudou) {
			setValues((current) => ({
				...current,
				contexto: contextoEmbarque,
			}));

			setValidator((current) => ({
				...current,
				validatorEmpresa: "false",
				validatorFilial: "false",
				validatorPedido: "false",
				validatorPrevisaoEmbarque: "false",
				validatorPrevisaoEntrega: "false",
				validatorStatus: "false",
				validatorPlacaCavalo: "false",
				validatorPlacaCarreta: "false",
				validatorPlacaCarreta2: "false",
				validatorProprietario: "false",
				validatorMotorista: "false",
				validatorIcms: "false",
				validatorFreteFiscal: "false",
				validatorMeioPagamento: "false",
				validatorEmbarcador: "false",
				validatorDestinatario: "false",
				validatorMercadoria: "false",
			}));
		}
	}, [contextoEmbarque, contextoEmbarqueMudou]);

	const preencherDadosEditando = useCallback(
		async (result) => {
			if (!result) return;
			const updatedValues = { ...values };
			const updatedValuesSelect = { ...valuesSelect };

			const pedidoSelecionado = opcoesPedido.find(
				(option) => option.pedido === result.pedido
			);

			if (pedidoSelecionado) {
				setDisabledFreteFiscal(!pedidoSelecionado.permiteAlterarFreteFiscal);
				if (contextoEmbarque !== "frota") {
					buscarTaxaIcms(
						pedidoSelecionado.embarcadorEstado,
						pedidoSelecionado.destinatarioEstado
					);
					setIcmsEmbutido(pedidoSelecionado?.icmsEmbutido);
					setIcmsBackup((current) => ({
						...current,
						icms: pedidoSelecionado?.icms,
					}));
				}
				updatedValuesSelect.pedido = {
					title: pedidoSelecionado.label,
					obj: pedidoSelecionado,
				};
				updatedValues.pedidoId = pedidoSelecionado.idPedido;
				updatedValues.valorEmbarqueId = pedidoSelecionado.valorEmbarqueId;
			}

			const frotaSelecionado = opcoesFrota.find(
				(option) => option.value === result.frota
			);
			if (frotaSelecionado) {
				updatedValuesSelect.frota = frotaSelecionado;
			}

			const aceiteSelecionado = opcoesFrota.find(
				(option) => option.value === result.aceite
			);
			if (aceiteSelecionado) {
				updatedValuesSelect.aceite = aceiteSelecionado;
			}

			const placaSelecionado = veiculo.find((option) => {
				return (
					option.caminhao?.placa === result.placaCavalo
				);
			});
			if (placaSelecionado) {
				const placa = placaSelecionado.caminhao?.placa ?? "";
				updatedValuesSelect.placaCavalo = {
					obj: placa,
					title: `${placa} - ${
						placaSelecionado.proprietarioVeiculo?.nome ?? ""
					}`,
				};
				updatedValues.veiculoId = placaSelecionado.idVeiculo;
			}

			const empresaSelecionado = empresaSub.find(
				(option) => option.nome === result.empresa
			);
			if (empresaSelecionado) {
				if (empresaSelecionado.regimeTributario === 1) {
					setSimplesNacional(true);
					setTimeout(() => {
						setValues((current) => ({ ...current, icms: "0,00" }));
					}, 100);
				}
				updatedValues.empresaId = empresaSelecionado.idEmpresaSub;
				updatedValues.empresa = empresaSelecionado.nome;
				updatedValuesSelect.empresa = {
					value: empresaSelecionado.nome,
					label: empresaSelecionado.nome,
					id: empresaSelecionado.idEmpresaSub,
				};
			}

			const filialSelecionado = filial.find(
				(option) => option.nome === result.filial
			);
			if (filialSelecionado) {
				updatedValuesSelect.filial = {
					value: filialSelecionado.nome,
					label: filialSelecionado.nome,
					id: filialSelecionado.idFilial,
				};
				updatedValues.filialId = filialSelecionado.idFilial;
			}

			const unidadeSelecionado = unidadeEmbarque.find(
				(option) => option.nome === result.unidEmbarque
			);
			if (unidadeSelecionado) {
				updatedValuesSelect.unidEmbarque = {
					value: unidadeSelecionado.nome,
					label: unidadeSelecionado.nome,
					id: unidadeSelecionado.idUnidadeEmbarque,
				};
				updatedValues.unidEmbarqueId = unidadeSelecionado.idUnidadeEmbarque;
			}

			const statusSelecionado = status.find(
				(option) => option.nome === result.status
			);
			if (statusSelecionado) {
				updatedValuesSelect.status = {
					value: statusSelecionado.nome,
					label: statusSelecionado.nome,
					id: statusSelecionado.idStatus,
				};
				updatedValues.statusId = statusSelecionado.idStatus;
			}

			const embalagemSelecionado = embalagem.find(
				(option) => option.nome === result.embalagem
			);
			if (embalagemSelecionado) {
				updatedValuesSelect.embalagem = {
					value: embalagemSelecionado.nome,
					label: embalagemSelecionado.nome,
					id: embalagemSelecionado.idEmbalagem,
				};
				updatedValues.embalagemId = embalagemSelecionado.idEmbalagem;
			}

			const mercadoriaSelecionado = mercadoria.find(
				(option) => option.nome === result.mercadoria
			);
			if (mercadoriaSelecionado) {
				updatedValuesSelect.mercadoria = {
					value: mercadoriaSelecionado.nome,
					label: mercadoriaSelecionado.nome,
					id: mercadoriaSelecionado.idMercadoria,
				};
				updatedValues.mercadoriaId = mercadoriaSelecionado.idMercadoria;
			}

			const usuarioResponsavelSelecionado = usuarioGerens.find(
				(option) => option.idUsuario === result.usuarioResponsavelId
			);
			if (usuarioResponsavelSelecionado) {
				updatedValuesSelect.usuarioResponsavel = {
					value: usuarioResponsavelSelecionado.usuario,
					label: usuarioResponsavelSelecionado.usuario,
					id: usuarioResponsavelSelecionado.idUsuario,
				};
				updatedValues.usuarioResponsavelId =
					usuarioResponsavelSelecionado.idUsuario;
			}

			const meioPagamentoSelecionado = meioPagamento.find(
				(option) => option.nome === result.meioPagamento
			);
			if (meioPagamentoSelecionado) {
				updatedValuesSelect.meioPagamento = {
					value: meioPagamentoSelecionado.nome,
					label: meioPagamentoSelecionado.nome,
					id: meioPagamentoSelecionado.idMeioPagamento,
				};
				updatedValues.meioPagamentoId =
					meioPagamentoSelecionado.idMeioPagamento;
			}

			const meioPagamento2Selecionado = meioPagamento.find(
				(option) => option.nome === result.meioPagamento2
			);
			if (meioPagamento2Selecionado) {
				updatedValuesSelect.meioPagamento2 = {
					value: meioPagamento2Selecionado.nome,
					label: meioPagamento2Selecionado.nome,
					id: meioPagamento2Selecionado.idMeioPagamento,
				};
				updatedValues.meioPagamento2Id =
					meioPagamento2Selecionado.idMeioPagamento;
			}

			const motivoSelecionado = motivo.find(
				(option) => option.motivo === result.motivo
			);
			if (motivoSelecionado) {
				updatedValuesSelect.motivo = {
					value: motivoSelecionado.motivo,
					label: motivoSelecionado.motivo,
					id: motivoSelecionado.idMotivo,
				};
				updatedValues.motivoId = motivoSelecionado.idMotivo;
			}

			const clienteSelecionado = clientes.find(
				(option) =>
					option.nomeFantasia === result.destinatario ||
					option.apelido === result.destinatario
			);
			if (clienteSelecionado) {
				updatedValuesSelect.destinatario = {
					title: clienteSelecionado.nomeFantasia,
					obj: clienteSelecionado,
				};
				updatedValues.clienteId = clienteSelecionado.idCliente;
			}

			updatedValues.motorista = result.veiculoMotorista
				? result.veiculoMotorista.nome
				: result.motorista;
			updatedValues.motoristaSelecionadoId =
				result?.veiculoMotorista?.idMotorista;

			setValues({
				...updatedValues,
				...Object.fromEntries(
					Object.entries(result).filter(
						([, value]) => value !== null && value !== undefined
					)
				),
			});
			validateEmptyValues();
			setValuesSelect(updatedValuesSelect);
			setValidator((current) => ({
				...current,
				validatorPedido: "true",
				validatorEmpresa: "true",
				validatorPrevisaoEmbarque: !isDataDoisMil(result.previsaoEmbarque)
					? "true"
					: "false",
				validatorPrevisaoEntrega: !isDataDoisMil(result.previsaoEntrega)
					? "true"
					: "false",
			}));
		},
		[
			buscarTaxaIcms,
			clientes,
			contextoEmbarque,
			embalagem,
			empresaSub,
			filial,
			meioPagamento,
			mercadoria,
			opcoesFrota,
			opcoesPedido,
			status,
			unidadeEmbarque,
			usuarioGerens,
			veiculo,
			motivo,
			values,
			valuesSelect,
			validateEmptyValues,
		]
	);

	useEffect(() => {
		if (!!props.dados && (!dadosPreenchidos.current || contextoEmbarqueMudou)) {
			preencherDadosEditando(props.dados);
			buscarImagemViagemFinalizada();
			dadosPreenchidos.current = true;
			setContextoEmbarqueMudou(false);
		}
	}, [
		props.dados,
		setContextoEmbarqueMudou,
		buscarImagemViagemFinalizada,
		preencherDadosEditando,
		contextoEmbarqueMudou,
		showToast,
	]);

	useEffect(() => {
		if (entregasCarregadasRef.current) return;
		const orig = props.dados?.entrega;
		if (!orig?.length) return;
		const normalizadas = orig.map((ent, idx) => {
			const pedidoEntregaSelecionado = opcoesPedido.find(
				(option) => option.idPedido === ent.pedidoId
			);
			return {
				localKey:
					ent.localKey ||
					(ent.idEntrega
						? `srv-${ent.idEntrega}`
						: `init-${Date.now()}-${idx}`),
				idEntrega: ent.idEntrega ?? 0,
				embarqueId: ent.embarqueId ?? 0,
				pedidoId: pedidoEntregaSelecionado?.idPedido ?? ent.pedidoId ?? 0,
				nomePedido: pedidoEntregaSelecionado?.label ?? ent.nomePedido ?? "",
				cte: ent.cte ?? "",
				classificacao: ent.classificacao ?? ent?.pedido?.classificacao ?? 0,
				freteMotorista: isNil(ent.freteMotorista)
					? ent?.pedido?.freteMotorista
					: ent.freteMotorista ?? 0,
				freteFiscal:
					ent.freteFiscal ?? pedidoEntregaSelecionado?.freteFiscal ?? 0,
				icms: ent.icms ?? pedidoEntregaSelecionado?.icms ?? 0,
				pedagio: ent.pedagio ?? ent?.pedido?.pedagio ?? 0,
				km: ent.km ?? 0,
				cliente: ent.cliente ?? ent?.pedido?.cliente ?? "",
				embarcador: ent.embarcador ?? ent?.pedido?.embarcador ?? "",
				destinarioId:
					ent.destinarioId ??
					ent.destinatario ??
					ent.pedido?.destinatarioId ??
					0,
				destinatarioTitle: ent.destinatario
					? `${ent.destinatario.nomeFantasia} | ${
							ent.destinatario.apelido ?? ""
					  }`
					: "",
				diClassificacao:
					ent.diClassificacao ?? ent?.clientePedido?.diClassificacao,
				diPedagio: ent.diPedagio ?? ent?.clientePedido?.diPedagio,
				icmsEmbutido: ent.icmsEmbutido ?? ent?.clientePedido?.icmsEmbutido,
				valorEmbarqueId:
					ent.valorEmbarqueId ?? ent?.pedido?.valorEmbarqueId ?? 0,
			};
		});

		setEntregas(normalizadas);
	}, [props.dados?.entrega, setEntregas, opcoesPedido]);

	useEffect(() => {
		if (entregasCarregadasRef.current) return;
		if (!props.dados?.entrega || entrega.length === 0) return;
		entrega.forEach((ent, index) => {
			const pedidoEntregaSelecionado = opcoesPedido.find(
				(option) => option.idPedido === ent.pedidoId
			);

			handleInputChange(
				{
					target: {
						name: "pedidoId",
						value: pedidoEntregaSelecionado?.idPedido || null,
					},
				},
				index
			);

			handleInputChange(
				{
					target: {
						name: "nomePedido",
						value: pedidoEntregaSelecionado?.label,
					},
				},
				index
			);
			handlePedidoEntregaChange({ obj: pedidoEntregaSelecionado }, index, ent);
		});
		entregasCarregadasRef.current = true;
	}, [
		props.dados?.entrega,
		opcoesPedido,
		entrega,
		handleInputChange,
		handlePedidoEntregaChange,
	]);

	useEffect(() => {
		if (profile?.token) {
			if (props.dados) {
				if (props.dados.cancelado) {
					setVerificaMotivo(false);
				}
				const aceiteSelecionado = opcoesFrota.find(
					(option) => option.value === "Não"
				);
				if (aceiteSelecionado) {
					setValues((current) => ({
						...current,
						aceite: aceiteSelecionado.value,
					}));
					setValuesSelect((current) => ({
						...current,
						aceite: aceiteSelecionado,
					}));
				}
			}

			dadosFilial.forEach((item) => {
				if (contextoEmbarque === item.contexto) {
					setValues((current) => ({
						...current,
						unidEmbarque: item.nomeFilial,
						filialEmpresaId: item.id,
					}));
				}
			});
			if (!props.dados) {
				setValuesSelect((current) => ({
					...current,
					usuarioResponsavel: {
						value: profile?.usuario.usuario,
						label: profile?.usuario.usuario,
						id: profile?.usuario.idUsuario,
					},
				}));
				setValues((current) => ({
					...current,
					usuarioResponsavelId: profile?.usuario.idUsuario,
				}));
				setValues((current) => ({
					...current,
					usuario: profile?.usuario.usuario,
				}));
			}
			setValues((current) => ({
				...current,
				contexto: contextoEmbarque,
			}));
		}
	}, [
		profile?.token,
		opcoesFrota,
		props.dados,
		contextoEmbarque,
		dadosFilial,
		adicionarEntrega,
		profile?.usuario.idUsuario,
		profile?.usuario.usuario,
	]);

	useEffect(() => {
		if (dadosRequestControllerRedux === "Fechar Modal Empresa") {
			handleCloseCadastroEmpresa();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Filial") {
			handleCloseCadastroFilial();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Unidade") {
			handleCloseCadastroUnidadeEmbarque();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Pedido") {
			handleCloseCadastroPedido();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Veiculo") {
			handleCloseCadastroVeiculo();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Embalagem") {
			handleCloseCadastroEmbalagem();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Status") {
			handleCloseCadastroStatus();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Motivo") {
			handleCloseCadastroMotivo();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal MeioPagamento") {
			handleCloseCadastroMeioPagamento();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
		if (dadosRequestControllerRedux === "Fechar Modal Mercadoria") {
			handleCloseCadastroMercadoria();
			setDadosRequestControllerRedux("");
			showToast("Cadastrado com sucesso!", "success");
		}
	}, [
		dadosRequestControllerRedux,
		handleCloseCadastroEmpresa,
		handleCloseCadastroFilial,
		handleCloseCadastroUnidadeEmbarque,
		handleCloseCadastroPedido,
		handleCloseCadastroVeiculo,
		handleCloseCadastroEmbalagem,
		handleCloseCadastroStatus,
		handleCloseCadastroMotivo,
		handleCloseCadastroMeioPagamento,
		handleCloseCadastroMercadoria,
		setDadosRequestControllerRedux,
		showToast,
	]);

	useEffect(() => {
		if (props.dados?.pedidoEmbarque?.permiteAlterarFreteFiscal) {
			setDisabledFreteFiscal(
				!props.dados.pedidoEmbarque?.permiteAlterarFreteFiscal
			);
		}
	}, [props.dados?.pedidoEmbarque?.permiteAlterarFreteFiscal]);

	const [taxaIcms, setTaxaIcms] = useState();

	const [diPedagio, setDiPedagio] = useState(false);

	const [diClassificacao, setDiClassificacao] = useState(false);

	const calcularIcms = useCallback(
		(freteFiscal) => {
			if (contextoEmbarque === "frota") {
				setValues((current) => ({ ...current, icms: "0,00" }));
				return;
			}

			let freteFiscalValue = freteFiscal;
			if (!freteFiscalValue) {
				freteFiscalValue = values.freteFiscal;
			}

			if (!freteFiscalValue) {
				freteFiscalValue = "0";
			}
			if (!values.classificacao) {
				values.classificacao = "0";
			}
			if (!values.pedagio) {
				values.pedagio = "0";
			}
			let taxaFreteFicasl = 0;
			let taxaPedagio = 0;
			let taxaClassificacao = 0;
			let taxaFreteFiscalReplace = 0;
			if (freteFiscalValue !== "0,00" && freteFiscalValue) {
				taxaFreteFicasl = freteFiscalValue.replace(".", "");
				taxaFreteFiscalReplace = taxaFreteFicasl.replace(",", ".");
			} else {
				taxaFreteFicasl = freteFiscalValue;
				taxaFreteFiscalReplace = taxaFreteFicasl.replace(",", ".");
			}
			let taxaPedagioReplace = 0;
			if (diPedagio) {
				if (!values.pedagio) {
					values.pedagio = "0";
				}
				if (values.pedagio !== "0,00" && values.pedagio) {
					taxaPedagio = values.pedagio.replace(".", "");
					taxaPedagioReplace = taxaPedagio.replace(",", ".");
				} else {
					taxaPedagio = values.pedagio;
					taxaPedagioReplace = taxaPedagio.replace(",", ".");
				}
			}
			let taxaClassificacaoReplace = 0;
			if (diClassificacao) {
				if (!values.classificacao) {
					values.classificacao = "0";
				}
				if (values.classificacao !== "0,00" && values.classificacao) {
					taxaClassificacao = values.classificacao.replace(".", "");
					taxaClassificacaoReplace = taxaClassificacao.replace(",", ".");
				} else {
					taxaClassificacao = values.classificacao;
					taxaClassificacaoReplace = taxaClassificacao.replace(",", ".");
				}
			}

			let somatoriaGeral =
				parseFloat(taxaFreteFiscalReplace) +
				parseFloat(taxaPedagioReplace) +
				parseFloat(taxaClassificacaoReplace);
			const somatoriaGeralString = somatoriaGeral.toString();
			const taxaCalculada =
				(somatoriaGeralString.replace(",", ".") / (1 - taxaIcms)) * taxaIcms;
			const taxaFormatada = taxaCalculada.toFixed(2).toString();
			const taxaFReplace = taxaFormatada.replace(".", ",");
			if (icmsEmbutido) {
				setValues((current) => ({ ...current, icms: "0,00" }));
			} else {
				if (!isNaN(taxaFReplace) || typeof taxaFReplace === "string") {
					setValues((current) => ({
						...current,
						icms: taxaFReplace === "NaN" ? "0,00" : taxaFReplace,
					}));
				}
			}
		},
		[
			contextoEmbarque,
			values,
			taxaIcms,
			icmsEmbutido,
			diPedagio,
			diClassificacao,
		]
	);

	useEffect(() => {
		if (
			!disabledFreteFiscal &&
			contextoEmbarque !== "frota" &&
			contextoEmbarqueMudou
		) {
			calcularIcms();
		}
	}, [
		disabledFreteFiscal,
		contextoEmbarque,
		contextoEmbarqueMudou,
		calcularIcms,
	]);

	const selectMessage = useMemo(() => {
		return (inputValue) => {
			return inputValue !== "" ? "Não há mais opções" : "Digite para buscar";
		};
	}, []);

	useEffect(() => {
		if (
			contextoEmbarque === "frota" &&
			!params?.origem &&
			contextoEmbarqueMudou
		) {
			setValues((current) => ({ ...current, icms: "0,00" }));
		}
	}, [values?.icms, contextoEmbarque, params?.origem, contextoEmbarqueMudou]);

	const isLoading = useMemo(() => {
		return !profile?.token || loading;
	}, [profile?.token, loading]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{!isLoading ? (
				<div className="flex-column">
					<FormTemplateEmbarque
						contextoEmbarque={contextoEmbarque}
						setValues={setValues}
						values={values}
						setValuesSelect={setValuesSelect}
						setValidator={setValidator}
						valuesSelect={valuesSelect}
						opcoesTemplate={opcoesTemplate}
						labelTemplate={labelTemplate}
						estiloFrota={estiloFrota}
						embarqueTemplate={embarqueTemplate}
						preencherDadosEditando={preencherDadosEditando}
						setEmpresaValido={setEmpresaValido}
						setPedidoValido={setPedidoValido}
						setDestinatarioValido={setDestinatarioValido}
						setIcmsBackup={setIcmsBackup}
						dadosFilial={dadosFilial}
					/>
					<FormEmbarqueTop
						pedidoValido={pedidoValido}
						pedidoOptions={pedidoOptions}
						setOpenCadastroPedido={setOpenCadastroPedido}
						setIdAtual={setIdAtual}
						setDisable={setDisable}
						taxaIcms={taxaIcms}
						contextoEmbarque={contextoEmbarque}
						icmsBackup={icmsBackup}
						clienteOptions={clienteOptions}
						destinatarioValido={destinatarioValido}
						setOpenCadastroCliente={setOpenCadastroCliente}
						setValues={setValues}
						calcularIcms={calcularIcms}
						values={values}
						empresaValido={empresaValido}
						setEmpresaValido={setEmpresaValido}
						empresaSub={empresaSub}
						setSimplesNacional={setSimplesNacional}
						setValuesSelect={setValuesSelect}
						setValidator={setValidator}
						setOpenCadastroEmpresa={setOpenCadastroEmpresa}
						valuesSelect={valuesSelect}
						openInformacao={openInformacao}
						setOpenInformacao={setOpenInformacao}
						setOpenCadastroFilial={setOpenCadastroFilial}
						filial={filial}
						estiloFrota={estiloFrota}
						labelFrota={labelFrota}
						selectMessage={selectMessage}
						setOpenCadastroStatus={setOpenCadastroStatus}
						disabledFreteFiscal={disabledFreteFiscal}
						previsaoEmbarqueValido={previsaoEmbarqueValido}
						previsaoEmbarqueRange={previsaoEmbarqueRange}
						setPrevisaoEmbarqueValido={setPrevisaoEmbarqueValido}
						setPrevisaoEmbarqueRange={setPrevisaoEmbarqueRange}
						dataHoraChegadaEmbarqueRange={dataHoraChegadaEmbarqueRange}
						setDataHoraChegadaEmbarqueRange={setDataHoraChegadaEmbarqueRange}
						dataHoraEmbarcadoRange={dataHoraEmbarcadoRange}
						setDataHoraEmbarcadoRange={setDataHoraEmbarcadoRange}
						previsaoEntregaValido={previsaoEntregaValido}
						previsaoEntregaRange={previsaoEntregaRange}
						setPrevisaoEntregaRange={setPrevisaoEntregaRange}
						setPrevisaoEntregaValido={setPrevisaoEntregaValido}
						isCadastro={isCadastro}
						dataHoraChegadaEntregaRange={dataHoraChegadaEntregaRange}
						setDataHoraChegadaEntregaRange={setDataHoraChegadaEntregaRange}
						dataHoraEntregueRange={dataHoraEntregueRange}
						setDataHoraEntregueRange={setDataHoraEntregueRange}
						veiculoOptions={veiculoOptions}
						setOpenCadastroVeiculo={setOpenCadastroVeiculo}
						mostrarInput={mostrarInput}
						props={props}
						abrirWhats={abrirWhats}
						verificaMotorista2={verificaMotorista2}
						calcular={calcular}
						opcoesFrota={opcoesFrota}
						status={status}
						setVeiculoOptions={setVeiculoOptions}
						setPedidoValido={setPedidoValido}
						setPedidoOptions={setPedidoOptions}
						setDiClassificacao={setDiClassificacao}
						setDiPedagio={setDiPedagio}
						defaultPedidoOptions={defaultPedidoOptions}
						setIcmsBackup={setIcmsBackup}
						params={params}
						simplesNacional={simplesNacional}
						setIcmsEmbutido={setIcmsEmbutido}
						buscarTaxaIcms={buscarTaxaIcms}
						opcoesPedido={opcoesPedido}
						setDisabledFreteFiscal={setDisabledFreteFiscal}
						setClienteOptions={setClienteOptions}
						clientes={clientes}
						pedido={pedido}
						setMostrarInput={setMostrarInput}
						defaultVeiculoOptions={defaultVeiculoOptions}
						setVerificaMorista2={setVerificaMorista2}
						veiculo={veiculo}
						setOpenModalEncontrarVeiculo={setOpenModalEncontrarVeiculo}
					/>
					<Entregas
						entrega={entrega}
						pedidoValido={pedidoValido}
						pedidoOptions={pedidoOptions}
						handleInputChange={handleInputChange}
						handlePedidoEntregaChange={handlePedidoEntregaChange}
						setOpenCadastroPedido={setOpenCadastroPedido}
						setIdAtual={setIdAtual}
						setDisable={setDisable}
						setEntregas={setEntregas}
						taxaIcms={taxaIcms}
						contextoEmbarque={contextoEmbarque}
						icmsBackup={icmsBackup}
						disabledFreteFiscalEntrega={disabledFreteFiEntrega}
						clienteOptions={clienteOptions}
						destinatarioValido={destinatarioValido}
						setOpenCadastroCliente={setOpenCadastroCliente}
						setValues={setValues}
						calcularIcms={calcularIcms}
						removeEntrega={removeEntrega}
						values={values}
						adicionarEntrega={adicionarEntrega}
						setValidator={setValidator}
						setValuesSelect={setValuesSelect}
						pedido={pedido}
						setPedidoOptions={setPedidoOptions}
					/>
					<FormEmbarqueBottom
						setIdAtual={setIdAtual}
						setDisable={setDisable}
						contextoEmbarque={contextoEmbarque}
						setValues={setValues}
						values={values}
						setValuesSelect={setValuesSelect}
						setValidator={setValidator}
						valuesSelect={valuesSelect}
						estiloFrota={estiloFrota}
						selectMessage={selectMessage}
						props={props}
						setOpenCadastroEmbalagem={setOpenCadastroEmbalagem}
						embalagem={embalagem}
						mercadoria={mercadoria}
						labelMercadoria={labelMercadoria}
						setOpenCadastroMercadoria={setOpenCadastroMercadoria}
						usuarioGerens={usuarioGerens}
						setOpenCadastroMeioPagamento={setOpenCadastroMeioPagamento}
						meioPagamento={meioPagamento}
						setVerificaMotivo={setVerificaMotivo}
						setOpenCadastroMotivo={setOpenCadastroMotivo}
						verificaMotivo={verificaMotivo}
						motivo={motivo}
						loadingCadastro={loadingCadastro}
						editarTemplate={editarTemplate}
						editar={editar}
						cadastrarTemplate={cadastrarTemplate}
						cadastrar={cadastrar}
						validator={validator}
						imagesFinalizacaoViagem={imagesFinalizacaoViagem}
						setIsOpenModalImage={setIsOpenModalImage}
						setSelectedImage={setSelectedImage}
						handleDeleteImage={handleDeleteImage}
						location={location}
						navigate={navigate}
					/>
					<ModaisCadastroViagem
						openCadastroPedido={openCadastroPedido}
						idAtual={idAtual}
						disable={disable}
						handleCloseCadastroPedido={handleCloseCadastroPedido}
						openCadastroUnidadeEmbarque={openCadastroUnidadeEmbarque}
						handleCloseCadastroUnidadeEmbarque={
							handleCloseCadastroUnidadeEmbarque
						}
						openCadastroFilial={openCadastroFilial}
						handleCloseCadastroFilial={handleCloseCadastroFilial}
						openCadastroEmpresa={openCadastroEmpresa}
						handleCloseCadastroEmpresa={handleCloseCadastroEmpresa}
						openCadastroVeiculo={openCadastroVeiculo}
						handleCloseCadastroVeiculo={handleCloseCadastroVeiculo}
						openCadastroMercadoria={openCadastroMercadoria}
						handleCloseCadastroMercadoria={handleCloseCadastroMercadoria}
						openCadastroEmbalagem={openCadastroEmbalagem}
						handleCloseCadastroEmbalagem={handleCloseCadastroEmbalagem}
						openCadastroStatus={openCadastroStatus}
						handleCloseCadastroStatus={handleCloseCadastroStatus}
						openCadastroCliente={openCadastroCliente}
						handleCloseCadastroCliente={handleCloseCadastroCliente}
						openCadastroMotivo={openCadastroMotivo}
						handleCloseCadastroMotivo={handleCloseCadastroMotivo}
						openCadastroMeioPagamento={openCadastroMeioPagamento}
						handleCloseCadastroMeioPagamento={handleCloseCadastroMeioPagamento}
						open={props.open}
						isOpenModalImage={isOpenModalImage}
						selectedImage={selectedImage}
						pedidoId={values.pedidoId}
						previsaoEmbarque={values.previsaoEmbarque}
						openModalEncontrarVeiculo={openModalEncontrarVeiculo}
						handleCloseEncontrarVeiculoIa={handleCloseEncontrarVeiculoIa}
						placaCavalo={values.placaCavalo}
						setIsOpenModalImage={setIsOpenModalImage}
					/>
				</div>
			) : (
				<LoadingComponent />
			)}
		</motion.div>
	);
}
export default CadastroViagem;
